import { createStyles } from '@material-ui/core';

export default () => createStyles({
  root: {
    padding: 16,
    borderRadius: 10,
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'visible',
    marginTop: '50px',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  title: {
    fontWeight: 500,
    fontSize: 24,
    marginBottom: 8,
  },
  table: {
    tableLayout: 'fixed',
    width: '100%',
  },
  tableBody: {
    flex: 1,
    overflowY: 'auto',
    overflow: 'hidden',
  },
  tableHead: {
    '& th': {
      fontSize: 14,
      color: '#999',
      fontWeight: 600,
      textTransform: 'uppercase',
      borderBottom: '1px solid #f0f0f0',
      padding: '8px 12px',
    },
  },
  tableRow: {
    '&:last-child td': { border: 0 },
    '& td': {
      padding: '10px 12px',
      fontSize: 13,
      borderBottom: '1px solid #f0f0f0',
    },
  },
  eventBadge: {
    display: 'inline-block',
    padding: '3px 10px',
    borderRadius: 50,
    fontSize: 12,
    fontWeight: 500,
  },
  sortableCell: {
    cursor: 'pointer',
    userSelect: 'none',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  sortCell: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    justifyContent: 'center',
  },
  sortIcon: {
    fontSize: 16,
    width: 16,
    height: 16,
  },
});
